import { ForwardedRef, forwardRef } from "react";

import {
  QuestionMarkCircleIcon,
  TrashCircleIcon,
  WarningCircleIcon,
} from "components/icons";
import ModalDialog from "components/ModalDialog";

import { useTranslationContext } from "context/TranslationContext";

interface ModalConfirmationProps {
  open: boolean;
  color?: "mustard" | "red" | "primary";
  title?: React.ReactNode;
  message?: React.ReactNode;
  submitLabel?: string;
  cancelLabel?: string;
  icon?: React.ReactNode;
  firstLineMessage?: string;
  secondLineMessage?: string;
  onCancel?: () => void;
  onSubmit?: () => void;
}

const ModalConfirmation = forwardRef<HTMLDivElement, ModalConfirmationProps>(
  (
    {
      open,
      color = "mustard",
      title,
      message,
      submitLabel,
      cancelLabel,
      icon,
      firstLineMessage,
      secondLineMessage,
      onCancel,
      onSubmit,
    },
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const { t } = useTranslationContext();

    return (
      <ModalDialog
        ref={ref}
        open={open}
        submitLabel={submitLabel || t("leave")}
        cancelLabel={cancelLabel || t("stay")}
        disableClose
        submitBtnColor={color}
        cancelBtnColor={color}
        onCancel={onCancel}
        onSubmit={onSubmit}
        text={
          <div className="flex flex-col items-center gap-4">
            <div>
              {icon ? (
                icon
              ) : color === "mustard" ? (
                <div className="text-mustard-600">
                  <WarningCircleIcon />
                </div>
              ) : color === "primary" ? (
                <div className="text-primary-500">
                  <QuestionMarkCircleIcon />
                </div>
              ) : (
                <div className="text-red-500">
                  <TrashCircleIcon />
                </div>
              )}
            </div>
            <div className="text-lg font-semibold">
              {title || t("unsaved_changes")}
            </div>
            <div className="text-base w-[85%]">
              {message || (
                <>
                  {firstLineMessage ||
                    t("component.modal_confirmation.message1")}
                  <br />
                  {secondLineMessage ||
                    t("component.modal_confirmation.message2")}
                </>
              )}
            </div>
          </div>
        }
      />
    );
  }
);

export default ModalConfirmation;
